import React from 'react';
import styles from './ToothChart.module.css';

// Simple FDI chart representation: upper arch 18→11 and 21→28, lower arch 48→41 and 31→38
export default function ToothChart({ selected = [], onSelect }) {
  const upperLeft = [18,17,16,15,14,13,12,11];
  const upperRight = [21,22,23,24,25,26,27,28];
  const lowerLeft = [48,47,46,45,44,43,42,41];
  const lowerRight = [31,32,33,34,35,36,37,38];

  const renderRow = (teeth) => (
    <div className={styles.row}>
      {teeth.map((n) => {
        const isActive = selected.includes(n);
        return (
          <button key={n} onClick={() => onSelect?.(n)} className={isActive ? styles.toothActive : styles.tooth}>
            {n}
          </button>
        );
      })}
    </div>
  );

  return (
    <div className={styles.chart}>
      {renderRow(upperLeft)}
      {renderRow(upperRight)}
      <div className={styles.spacer} />
      {renderRow(lowerLeft)}
      {renderRow(lowerRight)}
    </div>
  );
}

